import { render, staticRenderFns } from "./PolizaAsignableCuponAmigo.vue?vue&type=template&id=4e913c68&scoped=true&"
import script from "./PolizaAsignableCuponAmigo.vue?vue&type=script&lang=js&"
export * from "./PolizaAsignableCuponAmigo.vue?vue&type=script&lang=js&"
import style0 from "./PolizaAsignableCuponAmigo.vue?vue&type=style&index=0&id=4e913c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e913c68",
  null
  
)

export default component.exports